import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <p className="font-heading text-2xl text-primary-600">页面走丢了</p>
        <h1 className="mt-3 text-lg md:text-xl font-semibold text-foreground-950">
          您访问的页面不存在或已被删除
        </h1>
        <p className="mt-2 text-sm text-foreground-600 font-mono">{location.pathname}</p>
        <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-5-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/category"
            className="flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-100 px-6 py-2.5 text-sm text-secondary-900 transition-colors hover:bg-secondary-200"
          >
            <i className="ri-grid-fill" aria-hidden="true" />
            浏览全部漫画
          </Link>
        </div>
      </div>
    </div>
  );
}